import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { IMicrositeTopicPageConfig } from 'src/interfaces/page';
import { MicrositeService } from 'src/services';
import ProtectedPageRoute from 'src/utilities/auth/protectedPageRoute';
import { ReactElement } from 'react';
import ResolvePageComponent, {
  ResolvePageComponentProps,
} from 'src/components/pages/ResolvePageComponent';
import RootWidgetLayout from 'src/components/layouts/RootWidgetLayout';
import { Services } from 'src/services/types';
import { Translate } from 'next-translate';
import { myContainer } from 'src/services/inversify.config';

const TopicPageRoute = (props: ResolvePageComponentProps) => (
  <ResolvePageComponent {...props} />
);

export default TopicPageRoute;

// The previous default export was the TopicPage barrel (TopicPageWithContext),
// which carries this same .getLayout — replacing the default export without
// re-attaching it would silently drop RootWidgetLayout from every /topic/<slug>
// request. Body is identical to TopicPageWithContext.getLayout and to
// DynamicPageRoute.getLayout in [...urlSlug].tsx.
TopicPageRoute.getLayout = (
  page: ReactElement,
  _t: Translate,
  pageTitle?: string
) => {
  return <RootWidgetLayout pageTitle={pageTitle}>{page}</RootWidgetLayout>;
};

export const getServerSideProps = async (context) =>
  ProtectedPageRoute(context, async () => {
    const { req, params, locale, res } = context;
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=10, stale-while-revalidate=59'
    );

    let props: {
      pageData?: IMicrositeTopicPageConfig;
      pageTitle?: string;
    } = {};

    const { site } = req as { site?: IMicrositeConfiguration };

    if (params?.urlSlug && typeof params.urlSlug === 'string') {
      const micrositeService = myContainer.get<MicrositeService>(
        Services.MicrositeService
      );

      const topicPageConfig = site
        ? await micrositeService.getTopicPage(
            site.tenantId,
            site.packageId,
            params.urlSlug,
            locale
          )
        : undefined;

      const pageData = topicPageConfig
        ? {
            ...topicPageConfig,
            fullUrlSlug: `topic/${
              topicPageConfig?.fullUrlSlug ?? topicPageConfig?.urlSlug
            }`,
          }
        : undefined;

      props = { pageData, pageTitle: pageData?.pageName };
    }

    return JSON.parse(JSON.stringify(props));
  });
